import React from 'react';
import { X } from 'lucide-react';
import { useDesign } from '../../designs';

interface ModalProps {
  title: string;
  onClose: () => void;
  children: React.ReactNode;
}

export default function Modal({ title, onClose, children }: ModalProps) {
  const design = useDesign();
  const d = design.tokens;
  const fs = design.typography.fontSize;

  return (
    <div
      style={{
        position: 'fixed', inset: 0,
        backgroundColor: 'rgba(0,0,0,0.5)',
        display: 'flex', alignItems: 'flex-end', justifyContent: 'center',
        zIndex: 100,
      }}
      onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}
    >
      <div style={{
        backgroundColor: d.bgElevated,
        borderRadius: '12px 12px 0 0',
        width: '100%', maxWidth: '480px', maxHeight: '90vh',
        overflowY: 'auto', padding: '20px 20px 24px',
      }}>
        <div style={{
          display: 'flex', justifyContent: 'space-between', alignItems: 'center',
          marginBottom: '20px',
        }}>
          <h2 style={{
            fontFamily: "'Raleway', sans-serif", fontSize: fs.bodyInput, fontWeight: 700,
            letterSpacing: '3px', textTransform: 'uppercase',
            color: d.textPrimary, margin: 0,
          }}>{title}</h2>
          <button onClick={onClose} type="button" style={{
            background: 'none', border: 'none', cursor: 'pointer',
            padding: '4px', display: 'flex', alignItems: 'center',
          }}>
            <X size={18} strokeWidth={1.5} color={d.textSecondary} />
          </button>
        </div>
        {children}
      </div>
    </div>
  );
}
